import { FC } from 'react';
import { IconProps } from 'types';

export const LocationIcon: FC<IconProps> = ({ width = 12, height = 17, fill = '#969696' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00001 0C2.69176 0 0 2.57438 0 5.73751C0 7.24389 0.686627 9.24715 2.04076 11.6918C3.12826 13.6545 4.38639 15.4294 5.04076 16.3125C5.15134 16.4634 5.29591 16.5862 5.46277 16.6707C5.62963 16.7553 5.81407 16.7994 6.00114 16.7994C6.18821 16.7994 6.37265 16.7553 6.53951 16.6707C6.70637 16.5862 6.85094 16.4634 6.96152 16.3125C7.61477 15.4294 8.87402 13.6545 9.96152 11.6918C11.3134 9.2479 12 7.24464 12 5.73751C12 2.57438 9.30827 0 6.00001 0ZM6.00001 8.40002C5.52534 8.40002 5.06132 8.25926 4.66664 7.99555C4.27196 7.73183 3.96435 7.357 3.7827 6.91846C3.60105 6.47991 3.55352 5.99735 3.64612 5.5318C3.73873 5.06624 3.96731 4.6386 4.30295 4.30295C4.6386 3.96731 5.06624 3.73873 5.5318 3.64612C5.99735 3.55352 6.47991 3.60105 6.91846 3.7827C7.357 3.96435 7.73183 4.27196 7.99555 4.66664C8.25926 5.06132 8.40002 5.52534 8.40002 6.00002C8.39933 6.63632 8.14625 7.24637 7.69631 7.69631C7.24637 8.14625 6.63632 8.39933 6.00001 8.40002Z"
        fill={fill}
      />
    </svg>
  );
};
